/* tslint:disable */
/* eslint-disable */
/**
 * Thynk Direct API
 * The API for managing reservation for [Thynk Direct](https://thynk.cloud/).
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { LocationCaseRead } from './location-case-read';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationCaseRead } from './reservation-case-read';
// May contain unused imports in some cases
// @ts-ignore
import { ReservationMailCaseRead } from './reservation-mail-case-read';
// May contain unused imports in some cases
// @ts-ignore
import { UserCaseRead } from './user-case-read';

/**
 * A case within PleaseAskM. It is a collection of correspondence with a customer, it typically resolves around a reservation initiated by a reservation e-mail from a customer.
 * @export
 * @interface CaseRead
 */
export interface CaseRead {
  /**
   *
   * @type {string}
   * @memberof CaseRead
   */
  '@context'?: string | null;
  /**
   *
   * @type {string}
   * @memberof CaseRead
   */
  '@id'?: string;
  /**
   *
   * @type {string}
   * @memberof CaseRead
   */
  '@type'?: string;
  /**
   * the database identifier of a case
   * @type {number}
   * @memberof CaseRead
   */
  id?: number;
  /**
   *
   * @type {Array<ReservationMailCaseRead>}
   * @memberof CaseRead
   */
  mails?: Array<ReservationMailCaseRead>;
  /**
   * the partner to which this case belongs
   * @type {string}
   * @memberof CaseRead
   */
  partner?: string | null;
  /**
   *
   * @type {UserCaseRead}
   * @memberof CaseRead
   */
  assignee?: UserCaseRead | null;
  /**
   *
   * @type {UserCaseRead}
   * @memberof CaseRead
   */
  createdBy?: UserCaseRead | null;
  /**
   *
   * @type {UserCaseRead}
   * @memberof CaseRead
   */
  updatedBy?: UserCaseRead | null;
  /**
   * case number based on the active reservation
   * @type {string}
   * @memberof CaseRead
   */
  caseNumber?: string | null;
  /**
   * company name of reservation if available otherwise the mail
   * @type {string}
   * @memberof CaseRead
   */
  companyName?: string | null;
  /**
   * company contact person of the reservation if available otherwise the mail
   * @type {string}
   * @memberof CaseRead
   */
  companyContactperson?: string | null;
  /**
   * subject of the first received mail
   * @type {string}
   * @memberof CaseRead
   */
  subject?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CaseRead
   */
  intents?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof CaseRead
   */
  flags?: Array<CaseReadFlagsEnum>;
  /**
   * current status based on the markings of the reservation or mail
   * @type {string}
   * @memberof CaseRead
   */
  status?: string;
  /**
   * current marking based on the reservation or mail
   * @type {string}
   * @memberof CaseRead
   */
  marking?: CaseReadMarkingEnum;
  /**
   * datetime when a reservation mailing transition is scheduled
   * @type {string}
   * @memberof CaseRead
   */
  transitionAt?: string | null;
  /**
   *
   * @type {LocationCaseRead}
   * @memberof CaseRead
   */
  location?: LocationCaseRead | null;
  /**
   * first date a guest will arrive and check in
   * @type {string}
   * @memberof CaseRead
   */
  checkinDate?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CaseRead
   */
  types?: Array<CaseReadTypesEnum>;
  /**
   * indicates what the source of the case is
   * @type {string}
   * @memberof CaseRead
   */
  source?: string | null;
  /**
   * date when the case has last been opened
   * @type {string}
   * @memberof CaseRead
   */
  openedAt?: string | null;
  /**
   *
   * @type {ReservationCaseRead}
   * @memberof CaseRead
   */
  activeReservation?: ReservationCaseRead | null;
  /**
   *
   * @type {ReservationMailCaseRead}
   * @memberof CaseRead
   */
  activeMail?: ReservationMailCaseRead | null;
}

export const CaseReadFlagsEnum = {
  Ai: 'AI',
  Bricksandbasics: 'bricksandbasics',
  Broker: 'broker',
  Cancel: 'cancel',
  Language: 'language',
  Ota: 'ota',
  Pax: 'pax',
  MReady: 'm-ready',
  LongLeadTime: 'long-lead-time',
  ShortLeadTime: 'short-lead-time',
} as const;

export type CaseReadFlagsEnum =
  (typeof CaseReadFlagsEnum)[keyof typeof CaseReadFlagsEnum];
export const CaseReadMarkingEnum = {
  New: 'new',
  Start: 'start',
  AwaitingMailingLink: 'awaiting_mailing_link',
  LinkMailed: 'link_mailed',
  ProposalRequested: 'proposal_requested',
  AvailabilityChecking: 'availability_checking',
  AvailabilitySucceeded: 'availability_succeeded',
  AvailabilityFailed: 'availability_failed',
  HotelroomoptionChecking: 'hotelroomoption_checking',
  HotelroomoptionSucceeded: 'hotelroomoption_succeeded',
  HotelroomoptionFailed: 'hotelroomoption_failed',
  MeetingroomoptionChecking: 'meetingroomoption_checking',
  MeetingroomoptionSucceeded: 'meetingroomoption_succeeded',
  AwaitingMailingMeetingroomoptionChanges:
    'awaiting_mailing_meetingroomoption_changes',
  MeetingroomoptionChangesMailed: 'meetingroomoption_changes_mailed',
  MeetingroomoptionFailed: 'meetingroomoption_failed',
  AwaitingMailingProposal: 'awaiting_mailing_proposal',
  ProposalMailed: 'proposal_mailed',
  ProposalMailedManually: 'proposal_mailed_manually',
  ProposalAccepted: 'proposal_accepted',
  HotelroombookingConfirming: 'hotelroombooking_confirming',
  HotelroombookingSucceeded: 'hotelroombooking_succeeded',
  HotelroombookingFailed: 'hotelroombooking_failed',
  MeetingroombookingConfirming: 'meetingroombooking_confirming',
  MeetingroombookingSucceeded: 'meetingroombooking_succeeded',
  MeetingroombookingFailed: 'meetingroombooking_failed',
  AwaitingMailingConfirmation: 'awaiting_mailing_confirmation',
  ConfirmationMailed: 'confirmation_mailed',
  ConfirmationMailedManually: 'confirmation_mailed_manually',
  Cancelled: 'cancelled',
  Expired: 'expired',
  ProcessedManually: 'processed_manually',
  NoAction: 'no_action',
  Archived: 'archived',
} as const;

export type CaseReadMarkingEnum =
  (typeof CaseReadMarkingEnum)[keyof typeof CaseReadMarkingEnum];
export const CaseReadTypesEnum = {
  Mice: 'mice',
  Hotel: 'hotel',
} as const;

export type CaseReadTypesEnum =
  (typeof CaseReadTypesEnum)[keyof typeof CaseReadTypesEnum];
